import { useSelector } from "react-redux";
import { useSetWidgetAttribute } from "./useSetWidgetAttribute.js";
import { useCallback, useEffect } from "react";

export const useAdvancedFilterSettings = (widgetId) => {
  const setAttribute = useSetWidgetAttribute(widgetId);
  const buttons = useSelector(s => s.dashboard.widgets[widgetId].settings.buttons || []);

  const addButton = useCallback(() => {
    const newButtons = [
      ...buttons,
      {...getDefaultButton()}
    ];
    setAttribute('settings.buttons', newButtons);
  }, [buttons]);

  const moveButton = useCallback((dragIndex, hoverIndex) => {
    const newButtons = [...buttons]
    const [moved] = newButtons.splice(dragIndex, 1)
    newButtons.splice(hoverIndex, 0, moved)
    setAttribute('settings.buttons', newButtons)
  }, [buttons]);

  const removeButton = useCallback((id) => {
    if (window.confirm(I18n.t('advanced_filter_delete_button_confirmation'))){
      const newButtons = buttons.filter((s) => s.id !== id);
      setAttribute('settings.buttons', newButtons);
    }
  }, [buttons]);

  /**
   * Get default settings based on json schema.
   */
  const getDefaultButton = useCallback(() => {
    return {
      id: Math.random().toString(36).substring(7)
    }
  }, []);

  return {
    addButton,
    moveButton,
    removeButton
  }
}